
function Faq(){

    this.build();

}

Faq.prototype.build = function(){

    $('.faq-teaser__title').on('click', function(e){
        $(this).toggleClass('open');
        if( $(this).hasClass('open') ){
            gsap.set($(this).next('.faq-teaser__content'), {height:"auto"});
            gsap.from($(this).next('.faq-teaser__content'), 0.4, {height:0});
        }else{
            gsap.to($(this).next('.faq-teaser__content'), 0.4, {height:0});
        }
    });

};